import { render, staticRenderFns } from "./CollectionSpecificationsTab.vue?vue&type=template&id=060568fa&scoped=true&"
import script from "./CollectionSpecificationsTab.vue?vue&type=script&lang=js&"
export * from "./CollectionSpecificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060568fa",
  null
  
)

export default component.exports